<template>
  <K2Modal
    :fullscreen="false"
    :dialog="modal === 'preview'"
    @handleClose="$emit('handleClose')"
    @onConfirm="$emit('onConfirm')"
    :hideFooter="true"
    :hideHeader="true"
    v-if="state"
  >
    <!--heading-->
    <K2Row justify_content="center" class="position-relative pb-3" align="center" space-between="true">
      <K2Icon color="black" name="chevron_left" @onclick="$emit('handleClose')" link="true" style="top: 0" />
      <K2Heading type="h5" class-name="mb-0" color="black">
        {{ postCategory }}
        {{ state.title || lang('Preview Post') }}
      </K2Heading>
      <K2Button size="small" @onclick="$emit('handlePreviewSubmit')">{{ lang('Submit Post') }}</K2Button>
    </K2Row>
    <!--heading-->

    <div id="preview" class="m-2 m-md-4 py-2 preview">
      <!--tag student-->
      <NewPostPreviewTag :selectedStudents="selectedStudents" :levelList="levelList" :classList="classList" />

      <!--student information-->
      <div v-if="isMomentPost">
        <K2Text bold="true">{{ lang('Student Information') }}:</K2Text>
        <K2Row style="flex-wrap: wrap" class="mt-2 mb-3" v-if="selectedStudents && selectedStudents.length">
          <div class="newPostSetting__info">
            <span class="k2Tag">Name</span> {{ getStudentInfo('name') }} <span class="k2Tag">Class</span> {{ getStudentInfo('class') }}
            <span class="k2Tag">Age</span> {{ getStudentInfo('age') }}
          </div>
        </K2Row>
      </div>

      <!--post file-->
      <K2Carousel :slide-list="postFiles" v-if="postFiles && postFiles.length" />

      <div class="my-3">
        <!--broadcast post-->
        <div v-if="isBroadcastPost">
          <div v-if="state.content">
            <K2Text bold="true">{{ lang('Content') }}:</K2Text><br />
            <span v-html="state.content" />
          </div>
        </div>

        <!--newsfeed/moment post-->
        <div v-else>
          <!--content-->
          <div v-if="state.content">
            <K2Text bold="true"> {{ (layoutConfig && layoutConfig.contentLabel) || lang('Content') }}: </K2Text>
            <br />
            <span v-html="state.content" />
          </div>

          <!--PostLearningMoments for newsfeed-->
          <ActivityPreviewGoal v-if="isNewsfeed" :passdevelopmentgoals="state.PostLearningMoments" :post-type="postType" :isMomentPost="isMomentPost" />
          <!--content2-->
          <div v-if="checkContent(state.content2)">
            <K2Text bold="true"> {{ (layoutConfig && layoutConfig.content2Label) || lang('Content') }}: </K2Text>
            <br />
            <span v-html="state.content2" />
          </div>

          <!--content for newsfeed only-->
          <div v-if="!isMomentPost">
            <!--content3-->
            <div v-if="checkContent(state.content3)">
              <K2Text bold="true"> {{ (layoutConfig && layoutConfig.content3Label) || lang('Content') }}: </K2Text>
              <br />
              <span v-html="state.content3" />
            </div>
            <!--content4-->
            <div v-if="checkContent(state.content4)">
              <K2Text bold="true"> {{ (layoutConfig && layoutConfig.content4Label) || lang('Content') }}: </K2Text>
              <br />
              <span v-html="state.content4" />
            </div>

            <!--PostLearningMoments for moment-->
            <ActivityPreviewGoal v-if="isMomentPost" :passdevelopmentgoals="state.PostLearningMoments" :post-type="postType" :isMomentPost="isMomentPost" />

            <!--footer-->
            <NewPostPreviewFooter :state="state" :postType="postType" :isNewsfeed="isNewsfeed" :isBroadcastPost="isBroadcastPost" />
          </div>
        </div>
      </div>
    </div>
  </K2Modal>
</template>

<script>
import K2Modal from '@/uiComponents/k2Modal/k2Modal'
import K2Row from '@/uiComponents/k2Row/k2Row'
import K2Icon from '@/uiComponents/k2Icon/k2MAIcon'
import K2Heading from '@/uiComponents/k2Heading/k2Heading'
import { lang } from '../../../../../locale'
import uiVariable from '@/config/uiVariable'
import K2Button from '@/uiComponents/k2Button/k2Button'
import NewPostPreviewTag from '@/pages/activity/component/newPostComponent/preview/newPostPreviewTag'
import K2Text from '@/uiComponents/k2Text/k2Text'
import K2Carousel from '@/uiComponents/k2Carousel/k2Carousel'
import ActivityPreviewGoal from '@/pages/activity/component/activityPreviewGoal'
import NewPostPreviewFooter from '@/pages/activity/component/newPostComponent/preview/newPostPreviewFooter'

export default {
  name: 'NewPostPreview',
  components: { NewPostPreviewFooter, ActivityPreviewGoal, K2Carousel, K2Text, NewPostPreviewTag, K2Button, K2Heading, K2Icon, K2Row, K2Modal },
  props: ['modal', 'state', 'postType', 'selectedStudents', 'levelList', 'classList', 'postFiles', 'layoutConfig'],
  data() {
    return {
      uiVariable: uiVariable,
      postCategory: '',
      isMomentPost: false,
      isBroadcastPost: false,
      isNewsfeed: false,
    }
  },
  watch: {
    postType: function (value) {
      if (value) {
        this.handleSetting()
      }
    },
  },
  mounted() {
    this.handleSetting()
  },
  methods: {
    lang,
    handleSetting() {
      this.isMomentPost = false
      this.isBroadcastPost = false
      this.isNewsfeed = false
      this.postCategory = ''

      switch (this.postType) {
        case 'Feed':
        case 'Update':
          this.isNewsfeed = true
          this.postCategory = lang('Newsfeed') + ' :'
          break
        case 'Moment':
          this.isMomentPost = true
          this.postCategory = lang('Moments') + ' :'
          break
        case 'Broadcast':
          this.isBroadcastPost = true
          this.postCategory = lang('Broadcast') + ' :'
          break
        default:
          this.isMomentPost = false
          this.isBroadcastPost = false
          this.isNewsfeed = false
          this.postCategory = ''
          break
      }
    },
    getStudentInfo(type) {
      let student = this.selectedStudents?.[0]
      switch (type) {
        case 'name':
          return student.StudentName || student?.itemList?.[0]?.First_Name
        case 'class':
          return student?.StudentClassName || student?.itemList?.[0]?.ClassFullName
        case 'age':
          return student?.age || student?.itemList?.[0]?.age
      }
    },

    checkContent(content) {
      if (content) {
        return content !== 'undefined' && content !== 'null'
      } else {
        return false
      }
    },
  },
}
</script>
